import React from "react";

import { VStack } from "@UI/Components/Stack/Stack";
import { Text } from "@UI/Components/Text/Text";
import { ICandidate, ICandidateCardProps } from "../../types";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";

import { Rate } from "@Shared/Components/Rate/Rate";
import { Box } from "@UI/Components/Box/Box";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";
import { useFeatureFlag } from "@Libs/GrowthBook/hooks/useFeatureFlag";
import { CandidateOfferPrice } from "./CandidateOfferPrice";

export const CandidateOfferSection = (
  props: ICandidate & Pick<ICandidateCardProps, "onCandidateOfferModalOpen">
) => {
  const { currentUser } = useCurrentUser();
  const isSubscribed = currentUser?.subscribed ?? false;
  const isActivationRateEnabled = useFeatureFlag("new-activation-rate");

  const openOfferModal = () => props.onCandidateOfferModalOpen(props.conversationId);

  if (props.serviceOffer?.rateType === "estimate") {
    return (
      <VStack
        spacing="0"
        cursor="pointer"
        data-stop-offcanvas
        onClick={openOfferModal}
      >
        {isActivationRateEnabled ? (
          <CandidateOfferPrice
            serviceOffer={props.serviceOffer}
            isSubscribed={isSubscribed}
          />
        ) : (
          <>
            <Text
              fontSize="lg"
              fontWeight="bold"
              color="gray.800"
              m="0"
              textDecoration="underline"
            >
              <FormattedMessage
                {...messages["serviceRequest.offerDetail.visit"]}
              />
            </Text>
            <Text fontSize="sm">
              <FormattedMessage
                {...messages["serviceRequest.offerDetail.forQuote"]}
              />
            </Text>
          </>
        )}
      </VStack>
    );
  }

  return (
    <VStack
      spacing="0"
      alignSelf="flex-start"
      alignItems={isActivationRateEnabled ? "flex-start" : "flex-end"}
      textAlign={isActivationRateEnabled ? "start" : "end"}
    >
      {!props.serviceOffer ? (
        <Text fontSize={{ base: "xs", md: "sm" }}>
          <FormattedMessage
            {...messages[
              props.offerWithdrawn || props.offerAsked
                ? props.offerWithdrawn
                  ? "serviceRequest.offerWithdrawn"
                  : "serviceRequest.offerAsked"
                : "serviceRequest.noOffer"
            ]}
          />
        </Text>
      ) : (
        <Box cursor="pointer" data-stop-offcanvas onClick={openOfferModal}>
          {isActivationRateEnabled ? (
            <CandidateOfferPrice
              serviceOffer={props.serviceOffer}
              isSubscribed={isSubscribed}
            />
          ) : (
            <Text
              as="h5"
              fontWeight="bold"
              fontSize={{ base: "lg", md: "xl" }}
              m="0"
              textDecoration="underline"
            >
              <Rate
                unit={props.serviceOffer.billingUnit}
                cents={props.serviceOffer.rateCents}
                currency={props.serviceOffer.rateCurrency}
              />
            </Text>
          )}

          {props.serviceOffer.offersFreeEstimation && (
            <Text
              as="h5"
              fontWeight="bold"
              fontSize={{ base: "xs", md: "sm" }}
            >
              <FormattedMessage
                {...messages["serviceRequest.offerDetail.freeVisit"]}
              />
            </Text>
          )}
        </Box>
      )}
    </VStack>
  );
};

